import { captureException } from '@sentry/react'

export function tryLogoutIntercom() {
  // https://developers.intercom.com/installing-intercom/docs/intercom-javascript#section-intercomshutdown
  // https://app.intercom.com/a/apps/qiqpfgjg/inbox/inbox/conversation/26852700003989
  try {
    if (!window?.Intercom) return
    if (typeof window.Intercom !== 'function') return

    window?.Intercom('shutdown')
    // Make the Intercom bubble appear again, but without any data
    window.intercomSettings = { app_id: 'qiqpfgjg' }
    window?.Intercom('boot', window.intercomSettings)
  } catch (error) {
    captureException(error)
  }
}
